import { extendTheme } from '@chakra-ui/core';

const theme = extendTheme({
  styles: {
    global: (props: Record<string, any>) => ({
      body: {
        bg: props.colorMode === 'dark' ? 'gray.900' : 'gray.50',
      },
    }),
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: 'purple',
      },
    },
  },
});

export default theme;
